import { gql } from '@apollo/client';
import { DeliveryProgressMonitoringOfSlaDetailFilterType } from '../queries/getDeliveryProgressMonitoringOfSlaList';

export const GENERATE_SLA_DETAIL_DOWNLOAD_REPORT_FOR_DSP = gql`
    mutation GenerateSlaDetailDownloadReportForDsp($filter: DeliveryProgressMonitoringOfSlaDetailFilterTypeInput!, $timezone: String) {
        generateSlaDetailDownloadReportForDsp(filter: $filter, timezone: $timezone)
    }
`;

export interface GenerateSlaDetailDownloadReportForDspVariables {
    filter: DeliveryProgressMonitoringOfSlaDetailFilterType;
    timezone?: string;
}

export interface GenerateSlaDetailDownloadReportForDspResponse {
    generateSlaDetailDownloadReportForDsp: string;
}
